import { STACK_LAYERS, StackLayer } from '../data/tools';
import { Icon } from './icons';
import ToolLogo from './ToolLogo';

interface ToolStackMatrixProps {
  layers?: StackLayer[];
  /** Compact mode: first 3 layers, no descriptions — used on Home. */
  compact?: boolean;
}

/** "Delivery Architecture" tech-stack matrix — a row per capability layer, chips on the right. */
function ToolStackMatrix({ layers = STACK_LAYERS, compact = false }: ToolStackMatrixProps) {
  const rows = compact ? layers.slice(0, 3) : layers;

  return (
    <div className="stack-matrix">
      {rows.map(layer => (
        <div className="stack-row" key={layer.id}>
          <div className="stack-row-head">
            <div className="feature-icon">
              <Icon id={layer.icon} size={24} />
            </div>
            <div>
              <h4 className="feature-title">{layer.name}</h4>
              {!compact && <p className="feature-desc">{layer.description}</p>}
            </div>
          </div>
          <div className="stack-row-tools">
            {layer.tools.map(toolId => (
              <ToolLogo key={toolId} toolId={toolId} size={48} showLabel={!compact} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ToolStackMatrix;
